
module.directive('offcanvas', function() {
    return {
        restrict: 'E',
        scope: false,
        controllerAs: 'offcanvas',
        controller: function($scope, $element) {
            this.isOpen = false;
            this.isOpenable = false;

            var ctrl = this,
                sidebar, content;

            this.setSidebar = function(e) { sidebar = e; };
            this.setContent = function(e) { content = e; };

            this.open = function() {
                $element.addClass('open');
                this.isOpen = true;
            };
            this.close = function() {
                $element.removeClass('open');
                this.isOpen = false;
            };

            this.toggle = function() {
                if (this.isOpen) { this.close(); }
                else { this.open(); }
            };

            $scope.$on('$stateChangeStart', function() {
                ctrl.close();
            });
        },
    };
});

module.directive('offcanvasSidebar', function() {
    return {
        restrict: 'E',
        require: '^offcanvas',
        link: function(scope, element, attrs, canvas) {
            canvas.setSidebar(element);
        }
    };
});

module.directive('offcanvasContent', function() {
    return {
        restrict: 'E',
        require: '^offcanvas',
        link: function(scope, element, attrs, canvas) {
            canvas.setContent(element);
        }
    };
});